module.exports = __webpack_public_path__ + "images/parking.4c605522.png";